<div mat-dialog-title>

  <div class="flex flex-row justify-between">

    <h1 class="text-lg">Select Phone Number</h1>

    <button type="button" color="warn"
      (click)="closeDialog()"
      mat-icon-button><mat-icon>close</mat-icon></button>
  
  </div>

</div>

<mat-dialog-content>

  @if (loading()) {

    <mat-spinner></mat-spinner>

  }

  <mat-radio-group (change)="onChange($event.value)">

    @for (option of options(); track option.phone_number) {

      <mat-radio-button
        [value]="option">{{option.label}} {{formatPhoneNumber(option.phone_number)}}</mat-radio-button>

    }

  </mat-radio-group>

</mat-dialog-content>

<mat-dialog-actions>



</mat-dialog-actions>
